import { send as setAlert } from "./alert";
import api, { authDebug, defaultUrl } from "../utils/api";
import { get as getNotifications } from "./notification";
import { mine as getPermissions } from "./permissions";
import { CAN_LOGIN } from "../constants/permissions";

import {
  AUTH_ERROR,
  LOGIN_FAILED,
  LOGIN_SUCCESS,
  LOGOUT,
  USER_LOADED,
  PASSWORD_CHANGE
} from "./types";

export const permitted = (name) => async (dispatch) => {
  try {
    const res_permitted = await api.get(`/users/me/permitted/n/${name}`);
    return res_permitted?.status === 200;
  } catch (error) {
    return false;
  }
}

export const loadUser = () => async (dispatch) => {
  try {
    authDebug("loadUser:start", {
      hasToken: Boolean(localStorage.token),
      api: localStorage.api || null
    });
    const res = await api.get("/users/me");
    authDebug("loadUser:users-me-ok", {
      status: res.status,
      userUuid: res.data?.userUuid,
      personUuid: res.data?.uuid,
      licenseeUuid: res.data?.licenseeUuid
    });
    dispatch({
      type: USER_LOADED,
      payload: res.data,
    });

    try {
      await api.get(`/users/me/permitted/n/${CAN_LOGIN}`);
      authDebug("loadUser:can-login-ok");
    } catch (error) {
      authDebug("loadUser:can-login-failed", {
        status: error?.response?.status,
        data: error?.response?.data,
        url: error?.config?.url
      });
      console.warn("License user loaded without CAN.LOGIN permission.", {
        status: error?.response?.status,
        data: error?.response?.data,
        url: error?.config?.url,
      });
    }

    dispatch(getNotifications());
    dispatch(getPermissions());
    return true;

  } catch (err) {
    authDebug("loadUser:failed", {
      status: err?.response?.status,
      data: err?.response?.data,
      url: err?.config?.url,
      message: err?.message
    });
    console.error("Unable to load authenticated license user.", {
      status: err?.response?.status,
      data: err?.response?.data,
      url: err?.config?.url,
    });
    dispatch({
      type: AUTH_ERROR,
    });
  }
  return false;
};

export const tokenize = (token, url = null) => async (dispatch) => {
  try {
    authDebug("tokenize:start", {
      hasToken: Boolean(token),
      url
    });
    if (url) {
      localStorage.setItem("api", url);
      api.defaults.baseURL = `${url}api`;
    } else {
      localStorage.removeItem("api");
      api.defaults.baseURL = defaultUrl();
    }
    localStorage.setItem("token", token);

    dispatch({
      type: LOGIN_SUCCESS,
      payload: { token: token },
    });
    authDebug("tokenize:success", {
      api: localStorage.api || null,
      hasStoredToken: Boolean(localStorage.token)
    });
    return await dispatch(loadUser());
  } catch (error) {
    authDebug("tokenize:failed", {
      message: error?.message
    });
    console.error("Unable to persist license token.", error);
    dispatch({
      type: LOGIN_FAILED,
    });
  }
  return false;
}

export const exchangeRegistrationCode = (code) => async () => {
  try {
    const res = await api.post("/public-registration/exchange", { code });
    return res?.data?.success ? res.data : { success: false };
  } catch (error) {
    return {
      success: false,
      code: error?.response?.data?.code || "INVALID_AUTHORIZATION_CODE",
      message: error?.response?.data?.message || "The authorization code is invalid or expired."
    };
  }
};

export const login = (email, password) => async (dispatch) => {
  try {
    const res = await api.post("/auth", { email, password });
    dispatch({
      type: LOGIN_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    const errors = err?.response?.data?.errors || [];
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, "error")));
    }

    dispatch({
      type: LOGIN_FAILED,
    });
  }
};

export const changePassword = (userId, passwords) => async (dispatch) => {
  try {
    const res = await api.post(`/users/${userId}/password/change`, passwords);
    dispatch({
      type: PASSWORD_CHANGE,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: AUTH_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

export const register = ({firstName, lastName, phone, email, password}) => async (dispatch) => {
  try {
    const res = await api.post(`/users/public/register`, {
      firstName, lastName, phone, email, password
    });

    return { success: true, uuid: res.data.uuid, status: res.status, token: res.data.token };
  } catch (error) {
    console.log(error);
    return { success: false }
  }
}

export const logout = () => ({ type: LOGOUT });

